import {
  TickCorrect,
  RoleAdmin,
  RoleContentSupervisor,
  RoleContentSpecialist,
  RoleLandlord,
  RoleSupply,
  AgentAdmin,
  RoleRegionalSupplyHead,
  Financial,
  RoleBc,
  RoleBd,
} from 'common/components/svgs';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const RoleItem = ({ hash, role, isSelected, handleSelectRole }) => {
  const { t } = useTranslation();

  const SvgComp = useMemo(() => {
    switch (hash) {
      case 'role-admin':
        return RoleAdmin;
      case 'role-content-supervisor':
        return RoleContentSupervisor;
      case 'agent_admin':
        return AgentAdmin;
      case 'role-content-specialist':
        return RoleContentSpecialist;
      case 'role-landlord':
        return RoleLandlord;
      case 'role-supply':
        return RoleSupply;
      case 'role-regional-supply-head':
        return RoleRegionalSupplyHead;
      case 'financial':
        return Financial;
      case 'bd':
        return RoleBd;
      case 'bd-admin':
        return RoleBd;
      case 'regional-bd-head':
        return RoleBd;
      case 'bc':
        return RoleBc;
      default:
        return React.Fragment;
    }
  }, [hash]);

  return (
    <div
      className={classNames('role-item', {
        'role-item--selected': isSelected,
      })}
      role="presentation"
      onClick={handleSelectRole}
    >
      <SvgComp className="role-item__icon-role" />
      <div className="role-item__label">
        {role?.name ? role?.name : t(`cms.switch_role_modal.role.${role.slug}`)}
      </div>
      <If condition={isSelected}>
        <span className="role-item__icon-selected-wrapper">
          <TickCorrect className="role-item__icon-selected" />
        </span>
      </If>
    </div>
  );
};

RoleItem.propTypes = {
  hash: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  role: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    scopes: PropTypes.array.isRequired,
  }).isRequired,
  handleSelectRole: PropTypes.func.isRequired,
};

RoleItem.defaultProps = {
  hash: '',
  isSelected: false,
  role: {
    role: '',
    scopes: [],
  },
  handleSelectRole: () => {},
};

export default RoleItem;
